import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Persist } from 'formik-persist';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as dataSeed from '../shared/DataSeed';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, ModalHeader
} from 'reactstrap';
class Page2ChooseBank extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            pilihBank: localStorage.getItem('pilihBank') || '',
            agreementCheck: false,
            agreementBO: false,
            validationCode: '',
            isLoading: false,
            openModal: false,
            fotoSpecimen: '',
            imageHash: '', //Date.now(),
        }
        this.handleValidateClick = this.handleValidateClick.bind(this);
    }

    async handleValidateClick() {
        if (this.state.pilihBank.length > 0) {
            localStorage.setItem('pilihBank', this.state.pilihBank);
            localStorage.setItem('page', -2);
            this.setState({ page: -2 });
        } else {
            alert('Mohon isi data dengan lengkap');
        }
    }

    onChangeSelection(e, setFieldValue) {
        this.setState({ pilihBank: e.target.value });
        localStorage.setItem('pilihBank', e.target.value);
        setFieldValue(e.target.name, e.target.value);
    };

    handleSubmit = (values, { setSubmitting }) => {
        console.log(values.BankCode2);
        localStorage.setItem('pilihBank', values.BankCode2);
        localStorage.setItem('page', -2);
        this.props.history.push('/register');
        setSubmitting(false);
    }

    render() {

        const { bcaValidation } = this.props;

        let msgAlert;

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <h2 className="py-3">Pendaftaran Nasabah</h2>
                    <Fade in={true}>
                        <Formik
                            onSubmit={this.handleSubmit}
                        >
                            {({ errors, touched, values, isValid, setFieldValue, setFieldTouched }) => (
                                <Form autoComplete="off">
                                    <UncontrolledAlert color="warning">Sebelum melanjutkan mohon mempersiapkan dokumen pendukung KTP.</UncontrolledAlert>
                                    <p className="text-danger"><b>Sebaiknya menggunakan browser Chrome / Firefox / Safari</b></p>
                                    <p>Panduan Pembukaan Rekening online <a href="https://www.jasautamacapital.com/media/3501" target="__blank">Klik disini</a></p>
                                    {msgAlert}

                                    <FormGroup tag="fieldset">
                                        <legend>Pilih Bank Rekening yang Anda Miliki</legend>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label>Bank<span className="text-danger">*</span></Label>

                                                    <Field component="select" name="BankCode2"
                                                        className="form-control form-control-sm"
                                                        onChange={(e) => this.onChangeSelection(e, setFieldValue)}                                                >
                                                        <option value="" >-- Pilih --</option>
                                                        <option value={"BCA"}>BCA (Bank Central Asia)</option>
                                                        <option value={"BRI"}>BRI (Bank Rakyat Indonesia)</option>
                                                    </Field>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="3" xs="12" sm="12">
                                                <Button type="sumbit" color="primary" className="btn-block" >Pilih</Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12">
                                                Estimasi pembuatan akun 2 x 24 Jam Kerja*<br />
                                                Syarat dan Ketentuan Berlaku*
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <Persist name="registrasi" />
                                </Form>
                            )}
                        </Formik>
                    </Fade>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
   
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Page2ChooseBank);



// WEBPACK FOOTER //
// ./src/components/Page2ChooseBank.js